import React from "react";
import styled from "styled-components";

export const StepContainer = styled.div`
  min-width: 500px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const ProgressContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
`;

const Circle = styled.div`
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background-color: ${(props) => (props.active ? "#e60000" : "#f0b3b3")};
  position: relative;
`;

const Line = styled.div`
  width: 150px;
  height: 2px;
  background-color: ${(props) => (props.active ? "#e60000" : "#f0b3b3")};
  position: relative;
  left: 0px;
  transform: translateY(-50%);
`;

export const ProgressBar = ({ steps, currentStep, setCurrentStep }) => {
  // Ignoramos el primer paso (índice 0)
  return (
    <ProgressContainer>
      {steps.slice(1).map((_, index) => (
        <>
          <Circle type="button" onClick={() => setCurrentStep(index + 1)} active={index + 1 <= currentStep} />
          {index < steps.length - 2 && <Line active={index + 1 < currentStep} />}
        </>
      ))}
    </ProgressContainer>
  );
};

export const customTourStyles = {
  popover: (base) => ({
    ...base,
    "--reactour-accent": "#ef5a3d",
    borderRadius: "none",
    width: "fit-content",
    maxWidth: "none !important",
  }),
  //   maskArea: (base) => ({
  //     ...base,
  //     rx: radius,
  //   }),
  //   maskWrapper: (base) => ({
  //     ...base,
  //     color: "#ef5a3d",
  //   }),
  //   badge: (base) => ({
  //     ...base,
  //     left: "auto",
  //     right: "-0.8125em",
  //   }),
  //   controls: (base) => ({
  //     ...base,
  //     marginTop: 100,
  //   }),
  //   close: (base) => ({
  //     ...base,
  //     right: "auto",
  //     left: 8,
  //     top: 8,
  //   }),
};

export const StepText = styled.p`
  font-family: "Nunito";
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 20px;
  color: #293134;
  margin: 0;
  max-width: 750px;
  /* text-align: center; */
`;

export const StepTextSpan = styled.span`
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 20px;
  color: #293134;
  margin: 0;
`;

export const ButtonDejarDeMostrar = styled.button`
  font-family: "Nunito";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #e60000;
  border: none;
  background: none;
  cursor: pointer;
  margin: 0;
`;
